import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { CommunicationTemplate } from './communication-template.model';
import { CommunicationService } from './communication.service';

@Injectable()
export class CommunicationTemplateResolver implements Resolve<CommunicationTemplate> {
  constructor(private communicationService: CommunicationService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CommunicationTemplate> {
    return this.communicationService.template(route.paramMap.get('templateId'));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/communications/communication-template.resolver.ts